import React from 'react'

import { BaseContent, Button, Heading } from '@fourthwall/components'

import * as S from './MissingPermissions.styled'

type MissingPermissionsProps = {
  onTryAgain: () => void
}

export const MissingPermissions = ({ onTryAgain }: MissingPermissionsProps) => {
  return (
    <S.Container>
      <Heading type="h4" weight="semibold">
        <S.HeadingText>Allow to use your camera and microphone</S.HeadingText>
      </Heading>
      <BaseContent appearance="secondary">
        To record thank you notes, please grant permission to access your camera and microphone then
        refresh this page.
      </BaseContent>
      <S.Button>
        <Button appearance="primary" label="Try again" onClick={onTryAgain} />
      </S.Button>
    </S.Container>
  )
}
